import React from 'react';
import AdminAiSettingsPage from '../components/AdminAiSettings/AdminAiSettingsPage';

const AdminAiSettings = () => <AdminAiSettingsPage />;

export default AdminAiSettings;
